import styled from 'styled-components';

export const InputBusca = styled.input`
    height:40px;
    border:0;
    width: 100%;
    padding: 5px 10px;
    border-radius:4px;
    font-size:16px;
    position:sticky;
    top:0;
`;
